import React from 'react'
import { t } from 'ttag'

import { Competencies } from './tabs/Competencies/Competencies'
import { Details } from './tabs/Details/Details'
import { Modules } from './tabs/Modules/Modules'
import { PrioritisedOutcome } from './tabs/PrioritisedOutcome/PrioritisedOutcome'
import { Access } from './tabs/Access/Access'

import { getDefaultValues as getDetailsDefaultValues } from './tabs/Details/model'
import { getDefaultValues as getCompetenciesDefaultValues } from './tabs/Competencies/model'
import { getDefaultValues as getModulesDefaultValues } from './tabs/Modules/model'
import { getDefaultValues as getOutcomesDefaultValues } from './tabs/PrioritisedOutcome/model'
import { getDefaultValues as getAccessDefaultValues } from './tabs/Access/model'

const COMPETENCIES = 'competencies'
const DETAILS = 'details'
const MODULES = 'modules'
const PRIORITISED_OUTCOME = 'prioritisedOutcome'
const ACCESS = 'access'

export const TAB_NAMES = {
  COMPETENCIES,
  DETAILS,
  MODULES,
  PRIORITISED_OUTCOME,
  ACCESS,
}

export const getDefaultValues = isPositionManagement => ({
  ...getDetailsDefaultValues(),
  ...getCompetenciesDefaultValues(),
  ...getModulesDefaultValues(),
  ...getOutcomesDefaultValues(),
  ...(isPositionManagement ? getAccessDefaultValues() : {}),
})

export const getTabs = isPositionManagement => {
  const tabs = [
    { id: TAB_NAMES.DETAILS, label: t`Details` },
    { id: TAB_NAMES.COMPETENCIES, label: t`Competencies` },
    { id: TAB_NAMES.PRIORITISED_OUTCOME, label: t`Prioritised outcome` },
    { id: TAB_NAMES.MODULES, label: t`Modules` },
  ]

  return isPositionManagement
    ? [...tabs, { id: TAB_NAMES.ACCESS, label: t`Access` }]
    : tabs
}

export const getActiveTab = state => {
  const {
    form,
    language,
    projects,
    tab,
    hasInverviewModuleDisabled,
    isEditMode,
    showTemplates,
    isPositionManagement,
    setShowTemplates,
  } = state

  const tabs = {
    [TAB_NAMES.COMPETENCIES]: (
      <Competencies {...{ ...form, language, project: state.project }} />
    ),
    [TAB_NAMES.DETAILS]: (
      <Details {...{ ...form, projects, isPositionManagement }} />
    ),
    [TAB_NAMES.MODULES]: (
      <Modules
        {...{
          ...form,
          showTemplates,
          hasInverviewModuleDisabled,
          isEditMode,
          setShowTemplates,
        }}
      />
    ),
    [TAB_NAMES.PRIORITISED_OUTCOME]: (
      <PrioritisedOutcome {...{ ...form, language }} />
    ),
    [TAB_NAMES.ACCESS]: <Access {...{ ...form, language }} />,
  }

  return tabs[tab]
}

export const getInvalidState = state => {
  const { form, tabId } = state

  const {
    formState: { errors, isSubmitted },
  } = form

  const invalidState = {
    [TAB_NAMES.DETAILS]:
      [
        errors?.root,
        errors?.position,
        errors?.department,
        errors?.languages,
        errors?.category,
        errors?.positions,
      ].some(error => error !== null && error !== undefined) && isSubmitted,
    [TAB_NAMES.COMPETENCIES]: Boolean(errors?.competencies && isSubmitted),
    [TAB_NAMES.MODULES]: Boolean(
      (errors?.modules || errors?.template) && isSubmitted,
    ),
    [TAB_NAMES.PRIORITISED_OUTCOME]: Boolean(errors?.outcomes && isSubmitted),
    [TAB_NAMES.ACCESS]: Boolean(errors?.access && isSubmitted),
  }

  return invalidState[tabId]
}

export const getFinishedState = state => {
  const { form, tabId } = state

  const {
    formState: { errors, isSubmitted },
  } = form

  const finishedState = {
    [TAB_NAMES.DETAILS]:
      [
        errors?.root,
        errors?.position,
        errors?.department,
        errors?.languages,
        errors?.category,
        errors?.positions,
      ].every(error => error === null || error === undefined) && isSubmitted,
    [TAB_NAMES.COMPETENCIES]: !errors?.competencies && isSubmitted,
    [TAB_NAMES.MODULES]:
      (errors?.modules === null || errors?.modules === undefined) &&
      (errors?.template === null || errors?.template === undefined) &&
      isSubmitted,
    [TAB_NAMES.PRIORITISED_OUTCOME]: !errors?.outcomes && isSubmitted,
    [TAB_NAMES.ACCESS]: Boolean(errors?.access && isSubmitted),
  }

  return finishedState[tabId]
}
